<template>
  <div>
    <TheTeCommonHeaderSimpleCatchcopy>
      <template #catchcopy>
        <span class="block tracking-[.15em] md:inline">現役のプロがはじめての学習と副業を</span>
        <span
          class="tracking-[.15em]"
        >徹底サポートするプログラミングスクール</span>
      </template>
    </TheTeCommonHeaderSimpleCatchcopy>
    <main>
      <slot />
    </main>
    <TheTeCommonFooter />
  </div>
</template>

<script setup lang="ts">
useHead({
  htmlAttrs: {
    "data-theme": 'techacademy',
  },
})
</script>

<script lang="ts">
import { defineNuxtComponent } from '#app'
import TheTeCommonHeaderSimpleCatchcopy from '~/components/Te/TeCommon/Header/TheTeCommonHeaderSimpleCatchcopy/TheTeCommonHeaderSimpleCatchcopy.vue'
import TheTeCommonFooter from '~/components/Te/TeCommon/Footer/TheTeCommonFooter/TheTeCommonFooter.vue'

const options = {
  components: {
    TheTeCommonHeaderSimpleCatchcopy,
    TheTeCommonFooter,
  },
}

export default defineNuxtComponent(options)
</script>
